module.exports = __webpack_public_path__ + "media/img/venue_sample-4a35cd037e842b55e29dc996a693c0c3.png";